<div class="thanks-page-container">
    <div class="thanks-page-container-inner">
        <div class="thanks-page-title" [ngClass]="{'active-red': isHighlighted}" #title>
            Благодарности
        </div>
        <div class="thanks-page-content">
            <div *ngFor="let e of texts index as i">
                <app-thanks-el
                    [texts]="e"
                />
            </div>
        </div>
    </div>
</div>
